export default __webpack_public_path__ + "static/media/FDI.fa464fe5.png";